export enum Mode {
    ADD = 'Add',
    EDIT = 'Edit',
    CREATE = 'Create'
}

export interface CreateIngredientType {
    inputValue?: string;
    name: string;
    create?: boolean;
}

export const INGREDIENTS_TITLE = {
    ADD_INGREDIENTS: "Add Ingredients",
    EDIT_INGREDIENTS: "Edit Ingredients"
} 